import Framework, { BaseService } from '@greenville/framework';
import _ from 'lodash';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';
import ChatgptConfig from '../../../common/config/ChatgptConfig';

export default class CommonSearchUtilityService extends BaseService {
  constructor() {
    super(constants.GET_COMMON_SEARCH_UTILITY_DATA, 'commonSearchUtilityStatus');
  }

  handleEvent(eventName, event) {
    let urlPathName = '';
    let payload = {};
    if (event.payload.selectedTabValue === ChatgptConfig.TabList.AUDIT_LOG) {
      const headers = {
        [constants.BERLIN_TENANT_ID_HEADER]: event.payload.tenantId
      };
      payload = _.omit(event.payload, ['selectedTabValue', 'tenantId']);
      return this.getClient('evergreen').post(`/chat/table`, payload, { headers });
    }
    if (event.payload.selectedTabValue === ChatgptConfig.TabList.FEEDBACK) {
      urlPathName = '/userfeedback/table';
      const headers = {
        [constants.BERLIN_TENANT_ID_HEADER]: event.payload.tenantId
      };
      payload = _.omit(event.payload, ['selectedTabValue', 'tenantId']);
      return this.getClient('evergreen').post(`/userfeedback/table`, payload, { headers });
    }
    if (event.payload.selectedTabValue === ChatgptConfig.TabList.TRENDS) {
      if (event.payload.toggleBtnValue === 'count') {
        urlPathName = '/chatutility/getcounts';
        payload = _.omit(event.payload, ['selectedTabValue', 'toggleBtnValue', 'startDateTime', 'endDateTime']);
      }
      if (event.payload.toggleBtnValue === 'cluster') {
        const headers = {
          [constants.BERLIN_TENANT_ID_HEADER]: event.payload.tenantId
        };
        payload.identifierId = event.payload.bookId;
        payload = _.omit(event.payload, [
          'selectedTabValue',
          'toggleBtnValue',
          'startDateTime',
          'endDateTime',
          'tenantId'
        ]);
        return this.getClient('evergreen').post(`/trendsInsights/cluster`, payload, { headers });
      }
    }
    return this.getClient('evergreen').post(urlPathName, payload);
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      const dataExist = data?.data?.data?.length > 0 || data?.data?.length > 0;
      const notification = {
        open: true,
        type: dataExist ? 'success' : 'info',
        message: dataExist ? 'Data Fetched Successfully' : 'No Data Found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('commonSearchUtility').setResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('commonSearchUtility').resetStoreValues();
  }
}
